import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileAlt, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons'
import './MultiFileItem.scss'

const MultiFileItem = ({ file, deleteFile }) => {
    const truncateString = (str) => {
        if (str.length > 25) {
          return str.slice(0, 15) + '...' + str.slice(-6);
        }
        return str;
      };
    return (
        <>
            <li
                className="multifile-item"
                key={file.name}>
                <FontAwesomeIcon icon={faFileAlt} />
                <p>{truncateString(file.name)}</p>
                <div className="actions">
                        <FontAwesomeIcon icon={faTrash}
                            onClick={() => deleteFile(file.name)} />
                </div>
            </li>
        </>
    )
}

export default MultiFileItem